import httpRequest from '../request/indexBase'
import { local } from '@/utils/storage'
import { fetchEventSource } from '@microsoft/fetch-event-source'
import permissionHeader from '@/utils/permissionHeader'

// 查询应用中心分类列表数据
export function applicationHeadList() {
  return httpRequest.get({
    url: `/workflow/application/applicationHeadList`
  })
}

// 查询应用中心列表数据
export function applicationList(params) {
  return httpRequest.get({
    url: `/workflow/application/applicationList`,
    params
  })
}
// 查询智能体中心列表数据
export function pageByTypeCode(params) {
  return httpRequest.get({
    url: `/workflow/workflow-base/pageByTypeCode`,
    params
  })
}
// 查询工作台列表
export function applicationWorkList(params) {
  return httpRequest.get({
    url: '/workflow/workflow-info/getMyWorkbenchesPage',
    params
  })
}
// 应用中心跳转到聊天对话
export function skipChatAppDir(params) {
  return httpRequest.get({
    url: `/workflow/chat-title/skipChatAppDir`,
    params
  })
}
// 应用中心跳转到聊天对话
export function saveTeamRecordToWord(data) {
  return httpRequest.post({
    url: `/chat/teamwork-record/saveTeamRecordToWord`,
    data
  })
}
// 里面对话
export function skipChatApp(params) {
  return httpRequest.get({
    url: `/workflow/chat-title/skipChatApp`,
    params
  })
}

// 查询用户收藏应用分类
export function appBookmarkHeadList(params) {
  return httpRequest.get({
    url: `/workflow/application/appBookmarkHeadList`,
    params
  })
}

// 查询用户收藏应用列表
export function appBookmarkList(params) {
  return httpRequest.get({
    url: `/workflow/application/appBookmarkList`,
    params
  })
}

// 查询用户协同应用列表
export function pageTeamworkApplication(params) {
  return httpRequest.get({
    url: `/chat/teamwork-application/pageTeamworkApplication`,
    params
  })
}

// 创建群聊
export function creatTeamWork(data) {
  return httpRequest.post({
    url: `/chat/teamwork-application/creatTeamWork`,
    data
  })
}

// 添加应用到群聊
export function addApp2TeamworkConnection(data) {
  return httpRequest.post({
    url: `/chat/teamwork-app-connection/addApp2TeamworkConnection`,
    data
  })
}

// 聊天内添加应用到群聊
export function addAppConnection(data) {
  return httpRequest.post({
    url: `/chat/teamwork-app-connection/addAppConnection`,
    data
  })
}

// 聊天内删除应用到群聊
export function removeAppConnection(data) {
  return httpRequest.post({
    url: `/chat/teamwork-app-connection/removeAppConnection`,
    data
  })
}

// 查询群聊详情
export function queryTeamworkApplication(params) {
  return httpRequest.get({
    url: `/chat/teamwork-application/queryTeamworkApplication`,
    params
  })
}

// 解散群聊
export function disbandteamwork(params) {
  return httpRequest.get({
    url: `/chat/teamwork-application/disbandteamwork`,
    params
  })
}

// 修改群聊
export function updateTeamworkApplication(data) {
  return httpRequest.put({
    url: `/chat/teamwork-application`,
    data
  })
}

// 查询群聊会话列表
export function queryTitleList(params) {
  return httpRequest.get({
    url: `/chat/teamwork-title/queryTitleList`,
    params
  })
}

// 创建群聊会话列表
export function createTeamworkTitle(params) {
  return httpRequest.post({
    url: `/chat/teamwork-title/createTeamworkTitle`,
    params
  })
}

// 编辑会话列表
export function updateTeamTitle(data) {
  return httpRequest.put({
    url: `/chat/teamwork-title/updateTeamTitle`,
    data
  })
}

// 批量删除会话列表
export function deleteBatchTitle(data) {
  return httpRequest.put({
    url: `/chat/teamwork-title/deleteBatchTitle`,
    data
  })
}

// 查询会话内容列表
export function getChatContent(params) {
  return httpRequest.get({
    url: `/chat/teamwork-record/queryTeamworkRecordList`,
    params
  })
}
// 删除会话内容列表
export function deleteRecords(params) {
  return httpRequest.delete({
    url: `/chat/teamwork-record`,
    params
  })
}
// 查询当前对话的应用
export function getChatApp(params) {
  return httpRequest.get({
    url: `/chat/applicationJson`,
    params
  })
}

// 查询积分是否足够对话
export function queryPoint(params) {
  return httpRequest.get({
    url: `/points/feature-expect-points-config/queryPoint`,
    params
  })
}
// 获取模型列表
export function getModelList(params) {
  return httpRequest.get({
    url: `/workflow/model/getDialogueModelList`,
    params
  })
}
// 获取模型列表
export function getModelInfo(params) {
  return httpRequest.get({
    url: `/chat/teamwork-application/${params.id}`
  })
}
// 修改协同应用聊天实体信息
export function updateTeamChatInfo(data) {
  return httpRequest.put({
    url: `/chat/teamwork-application`,
    data
  })
}
// 停止对话
export function chatStop(id) {
  return httpRequest.get({
    url: `/chat/chatStop/${id}`
  })
}
// 发送会话
export function sendChat(data, onopen, onmessage, onclose, onerror, ctrl) {
  return fetchEventSource(process.env.VUE_APP_API_URL + '/chat/chatTeamworkOpenAiJson', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: 'text/event-stream',
      token: local.get('TOKEN'),
      ...permissionHeader()
    },
    body: JSON.stringify(data),
    signal: ctrl.signal,
    openWhenHidden: true,
    onopen(response) {
      // 开启流
      console.log('onopen')

      onopen && onopen(response)
    },
    onmessage(event) {
      // 监听流
      onmessage && onmessage(event)
    },
    onclose(e) {
      // 关闭流
      onclose && onclose(e)
    },
    onerror: (e) => {
      //返回流报错
      onerror && onerror(e)
      throw e
    }
  })
}

// 重连
export function reconnectionChat(runId, onopen, onmessage, onclose, onerror, ctrl) {
  return fetchEventSource(
    process.env.VUE_APP_API_URL + `/chat/chatTeamworkOpenAiJsonContinue/${runId}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'text/event-stream',
        token: local.get('TOKEN'),
        ...permissionHeader()
      },
      signal: ctrl.signal,
      openWhenHidden: true,
      onopen(response) {
        // 开启流
        console.log('onopen')

        onopen && onopen(response)
      },
      onmessage(event) {
        // 监听流
        onmessage && onmessage(event)
      },
      onclose(e) {
        // 关闭流
        onclose && onclose(e)
      },
      onerror: (e) => {
        //返回流报错
        onerror && onerror(e)
        throw e
      }
    }
  )
}

// 对话分享短链生成
export function shareChatRecordLink(data) {
  return httpRequest.post({
    url: `/workflow/shareChatRecordLink`,
    data
  })
}
// 查询分享内容
export function queryShareChatRecord(params) {
  return httpRequest.get({
    url: `/workflow/queryShareChatRecord/${params.id}`
  })
}
